// Money-view unitat drawer: title saldo + owed summary inline, quick
// toggles for the despesa/ajust forms, then the unitat's entries
// (desc by effective date, no running saldo).

import { useFactures } from './useFacturesContext';
import { FACTURES_UNITATS } from '../../constants/roles';
import { dateOf, fmtEUR } from './facturesTypes';
import { DespesaForm } from './DespesaForm';
import { EntryItem } from './EntryItem';
import {
	DrawerTitle,
	Row,
	EntriesList,
	NoteText,
	Panel,
	SmallButton,
	FormRow,
} from './Factures.styles';
import { Button, FormGroup, Input, Label } from '../Shared/FormStyles';

export const UnitatDrawer = () => {
	const fac = useFactures();
	const { detail, selected } = fac;
	if (!detail || !selected) return null;

	return (
		<Panel>
			<Row style={{ alignItems: 'center', flexWrap: 'wrap' }}>
				<DrawerTitle>
					{FACTURES_UNITATS.find((u) => u.id === selected)?.nom ?? selected}
					{' — '}
					<span
						style={{
							fontWeight: 800,
							fontSize: '1.35rem',
							color:
								detail.balanceCents < 0 ? '#c0392b' : '#2b7a2b',
						}}
					>
						{fmtEUR(detail.balanceCents)}
					</span>
				</DrawerTitle>
				{(() => {
					const owed = detail.owed.filter((o) => o.owedCents !== 0);
					if (owed.length === 0) return null;
					return (
						<NoteText>
							{owed
								.map((o) =>
									o.owedCents > 0
										? `${o.capName}: li devem ${fmtEUR(o.owedCents)}`
										: `${o.capName}: ens deu ${fmtEUR(-o.owedCents)}`
								)
								.join(' · ')}
						</NoteText>
					);
				})()}
				<span style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
					<SmallButton
						onClick={() => {
							fac.setShowForm((v) => !v);
							fac.setShowAjust(false);
						}}
					>
						{fac.showForm ? 'Cancel·la' : '＋ Despesa'}
					</SmallButton>
					<SmallButton
						onClick={() => {
							fac.setShowAjust((v) => !v);
							fac.setShowForm(false);
						}}
					>
						{fac.showAjust ? 'Cancel·la' : '＋ Ajust'}
					</SmallButton>
					<SmallButton title="Tanca" onClick={() => fac.openUnitat(selected)}>
						×
					</SmallButton>
				</span>
			</Row>
			{fac.showForm && <DespesaForm />}
			{fac.showAjust && (
				<Panel style={{ background: '#eef4ff' }}>
					<FormRow>
						<FormGroup>
							<Label>Ajust — import</Label>
							<Input
								value={fac.aAmount}
								inputMode="decimal"
								placeholder="-20,00"
								onChange={(e) => fac.setAAmount(e.target.value)}
							/>
							<NoteText>(+ ingressa / − treu)</NoteText>
						</FormGroup>
						<FormGroup>
							<Label>Motiu *</Label>
							<Input
								value={fac.aNote}
								placeholder="p. ex. arrossegament curs anterior"
								onChange={(e) => fac.setANote(e.target.value)}
							/>
						</FormGroup>
						<FormGroup style={{ flex: '0 0 auto' }}>
							<Label style={{ visibility: 'hidden' }}>.</Label>
							<Button
								onClick={fac.addAjust}
								disabled={!fac.aAmount}
							>
								Registra
							</Button>
						</FormGroup>
					</FormRow>
				</Panel>
			)}
			<EntriesList>
				{[...detail.entries]
					.sort((a, b) => {
						const da = dateOf(a);
						const db = dateOf(b);
						return da < db ? 1 : da > db ? -1 : 0;
					})
					.map((e) => (
						<EntryItem key={e._id} entry={e} saldo={null} />
					))}
			</EntriesList>
			{detail.entries.length === 0 && (
				<NoteText>Sense apunts per a aquest curs.</NoteText>
			)}
		</Panel>
	);
};

